import { useContext } from "react";
import { CartContext, CartContextType } from "../context/cart-context";

export function useCart(): CartContextType {
  const context = useContext(CartContext);

  if (context === undefined) {
    throw new Error("useCart must be used within a CartProvider");
  }

  return context;
}
